export const requestListConstants = {
    SET_RECORDS_REQUEST: 'SET_RECORDS_REQUEST',
    SET_ATTACHMENTS_REQUEST: 'SET_ATTACHMENTS_REQUEST',
    SET_SELECTED_ROWS: 'SET_SELECTED_ROWS',
    SET_SELECTED_ROW: 'SET_SELECTED_ROW',
    SET_PAGE_SIZE: 'SET_PAGE_SIZE',
    PRINT_END: 'PRINT_END',
    EXPORT_END: 'EXPORT_END',
    RETRIEVE_LAST_STATE: 'RETRIEVE_LAST_STATE',
};
